import { render, staticRenderFns } from "./ScreenshotDialog.vue?vue&type=template&id=648cbf7f&scoped=true&"
import script from "./ScreenshotDialog.vue?vue&type=script&lang=ts&"
export * from "./ScreenshotDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenshotDialog.vue?vue&type=style&index=0&id=648cbf7f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648cbf7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDialog,VImg})
